import { render } from "./3DModelTab.vue?vue&type=template&id=432d8684"
import script from "./3DModelTab.vue?vue&type=script&lang=js"
export * from "./3DModelTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__